import React from 'react';
import * as css from './LecturersDisplay.css';
import {TTimetableLecturer} from '../../../../../redux/timetable/timetable.type';

const MAX_AVATARS = 4;

interface LecturersDisplayProps {
    lecturers: TTimetableLecturer[];
    isBreak?: boolean;
}

function LecturersDisplay({lecturers, isBreak}: LecturersDisplayProps) {
    if(isBreak || lecturers.length === 0) {
        return <css.lecturersPlaceholder />;
    }

    if(lecturers.length === 1) {
        return (
            <css.lecturerRow>
                <css.avatar $image={lecturers[0].image} />
                <css.lecturerName>
                    {lecturers[0].firstName} {lecturers[0].lastName}
                </css.lecturerName>
            </css.lecturerRow>
        );
    }

    const visibleAvatars = lecturers.slice(0, MAX_AVATARS);
    const overflowCount = Math.max(0, lecturers.length - MAX_AVATARS);

    return (
        <css.avatarsRow>
            {visibleAvatars.map(l => <css.avatar key={l.lid} $image={l.image} />)}
            {overflowCount > 0 && <css.overflowBadge>+{overflowCount}</css.overflowBadge>}
        </css.avatarsRow>
    );
}

export default LecturersDisplay;
